// Selo "Transferido" na lista de conversas: regra unica dos 3 shells (QR,
// Business e o compartilhado de Instagram, Messenger e widget).
//
// Regra do dono (2026-10-10): o selo so aparece quando o agente passou a
// conversa para UMA PESSOA (responsavel membro gravado pela transferencia do
// agente, source agent_handoff). Handoff sem destino deixa o contato SEM
// responsavel e SEM selo nenhum: ninguem vai responder, nem agente nem membro,
// e a lista mostra isso pela ausencia de responsavel, nao por um selo. Vale
// tambem para o estado de handoff da InfinitAgents sem responsavel (fila
// geral antiga): sem selo.
// Depois que alguem da equipe reatribui a conversa, o selo sai: vale o nome
// do novo responsavel.
export function transferidoBadge({ handoff, assigned, loading = false }) {
  void handoff;
  void loading;
  const paraUmaPessoa = !!assigned
    && assigned.type === 'member'
    && assigned.source === 'agent_handoff';
  if (paraUmaPessoa) {
    return {
      show: true,
      title: `Transferido pelo agente para ${assigned.name || 'um atendente'}`,
    };
  }
  return { show: false, title: '' };
}
